module.exports = __webpack_public_path__ + "img/50.f9132f5b.png";